import React, { useState, useEffect } from 'react';
import { CardBody, Card, CardHeader } from 'reactstrap';
import { CarouselsData } from 'Data/Bonus-ui';
import Image from 'CommonElements/Media';
import Slider from 'react-slick';
import { H5 } from 'AbstractElements';
import {
    handleDeletePhotos,
} from './TreatmenUtilComponents';
import { useDispatch } from 'react-redux';

export const CarouselPhotosTreatment = ({ slides, rtl, title, lazyLoad, autoplay, focusOnSelect, images, setRefetch }) => {
const dispatch = useDispatch();

var settings = {
    dots: true,
    infinite: true,
    autoplay: autoplay,
    speed: 100,
    arrows: false,
    slidesToShow: slides,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoPlay: true,
    centerPadding: '10px',
    centerMode: false,
    rtl: rtl,
    focusOnSelect: focusOnSelect,
    lazyLoad: lazyLoad,
    responsive: [
    {
    breakpoint: 1400,
    settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
    }
    },
    {
    breakpoint: 800,
    settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
    }
    },
    {
    breakpoint: 600,
    settings: {
        slidesToShow: 2,
        slidesToScroll: 2
    }
    },
    {
    breakpoint: 480,
    settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
    }
    },
]
};
const [clickedIndex, setClickedIndex] = useState(null);

useEffect(() => {
    console.log(clickedIndex, 'clickedIndex');
}, [clickedIndex]);

const handleDelete = (pivot_id) => {
    handleDeletePhotos(dispatch, pivot_id, setRefetch, setClickedIndex);
}
return (
    <Card>
    <CardHeader className="pb-0">
        <H5>{title}</H5>
    </CardHeader>
    <CardBody>
        <Slider {...settings} >
        {(images && images.length > 0 ? images : CarouselsData).map((item, index) => (
            <div className="item" key={index}>
                <Image
                attrImage={{
                    src: item.photo || item,
                    alt: `Slide ${index + 1}`,
                    style: { width: '100%', height: 'auto', objectFit: 'cover' , borderRadius: '8px', padding: '1px' }
                }}
                />
                <div 
                style={{ 
                    width: '99%', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    background: clickedIndex === item.pivot_id ? '#52c41a' : '#ff4d4f',
                    color: '#fff', 
                    padding: '5px 0',
                    cursor: 'pointer', 
                    borderRadius: '0 0 8px 8px', 
                    margin: '1px auto 0 auto'
                }}
                onClick={() => handleDelete(item.pivot_id)}
            >
                <i className="icon-trash" style={{ padding: '2px 0' }}></i> Delete
            </div>
            </div>
        ))}
        </Slider>
    </CardBody>
    </Card>
);
};

export default CarouselPhotosTreatment;